import { useContext } from "react";
import AuthStatus from "../AuthStatus/AuthStatus";
import "./style.css";
import RegistrationContext from "../../contexts/RegistrationContext";
import logo from "../../assets/ecmlpkdd2026_logo.png";

const NavBar = ({ boxed }) => {
  const { loading } = useContext(RegistrationContext);

  return (
    <div className="navbar">
      <div className={`navbar-inner ${boxed && "boxed"}`}>
        <img src={logo} height="61" alt="ECML PKDD 2026" id="ecmlLogo" />
        {!loading && <AuthStatus />}
      </div>
    </div>
  );
}

export default NavBar;
